import { render, staticRenderFns } from "./EternityUpgradeButton.vue?vue&type=template&id=0b4344ef&scoped=true&"
import script from "./EternityUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./EternityUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4344ef",
  null
  
)

export default component.exports